import axios from "axios";
import { decodeToken, isExpired } from "../auth/token";

const API = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// -----------------------------
// Request Interceptor
// -----------------------------
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");

  if (token) {
    if (isExpired(token)) {
      localStorage.removeItem("authToken");
      window.location.href = "/login";
      return config;
    }

    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// -----------------------------
// Response Interceptor
// -----------------------------
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;

    if (status === 401) {
      localStorage.removeItem("authToken");
      window.location.href = "/login";
    }

    if (data?.two_factor_required) {
      window.location.href = "/two-factor";
    }

    if (data?.email_verified === false) {
      window.location.href = "/verify-email";
    }

    return Promise.reject(error);
  }
);

export default API;
